import { useState } from 'react'
import { Dialog, Toggletip } from '../kit'

// The (i) for a reason whose length the screen does not control: the data
// element catalogue's reasons, a refusal naming the roles that hold an act, a
// note the API writes. The spec keeps a toggletip to 200 characters and sends
// anything longer to a drawer, and some of these run to five hundred. Cutting
// them would change what they say, so a short reason opens as a toggletip and a
// long one opens the same (i) as a drawer with the whole sentence.
//
// hover is passed to the toggletip, so a short reason opens on hover and focus
// where a screen asks for that. A long one still opens its drawer on a press:
// a drawer that opened because a pointer crossed it would be a trap.

const TIP_LIMIT = 200

export function ReasonTip({ label, text, hover }: { label: string; text: string | undefined | null; hover?: boolean }) {
  const [open, setOpen] = useState(false)
  const words = (text ?? '').trim()
  if (words === '') return null
  if (words.length <= TIP_LIMIT) return <Toggletip label={label} hover={hover}>{words}</Toggletip>
  return (
    <span className="kit-tip">
      <button type="button" className="kit-tip-button" aria-label={label} aria-haspopup="dialog" onClick={() => setOpen(true)}>
        i
      </button>
      <Dialog shape="drawer" kind="record" open={open} onClose={() => setOpen(false)} title={label}>
        <p className="vd-reason">{words}</p>
      </Dialog>
    </span>
  )
}
